import { DatePipe, isPlatformBrowser } from '@angular/common';
import { Component, HostListener, OnDestroy, PLATFORM_ID, inject, signal } from '@angular/core';
import { Router, RouterLink } from '@angular/router';

import { User } from '../../models/api-response.model';
import { AuthenticationService } from '../../services/authentication_service';
import { ThemeService } from '../../services/theme.service';

@Component({
  selector: 'app-portal-header',
  standalone: true,
  imports: [DatePipe, RouterLink],
  templateUrl: './portal-header.component.html',
  styleUrls: ['./portal-header.component.scss']
})
export class PortalHeaderComponent implements OnDestroy {
  private readonly authService = inject(AuthenticationService);
  private readonly router = inject(Router);
  private readonly platformId = inject(PLATFORM_ID);
  private clockTimer?: ReturnType<typeof setInterval>;
  readonly themeService = inject(ThemeService);

  isProfileMenuOpen = false;
  readonly currentDateTime = signal(new Date());

  constructor() {
    if (isPlatformBrowser(this.platformId)) {
      this.clockTimer = setInterval(() => {
        this.currentDateTime.set(new Date());
      }, 1000);
    }
  }

  get greeting(): string {
    const hour = this.currentDateTime().getHours();

    if (hour < 12) {
      return 'Good Morning';
    }

    if (hour < 17) {
      return 'Good Afternoon';
    }

    if (hour < 21) {
      return 'Good Evening';
    }

    return 'Good Night';
  }

  get currentUserName(): string {
    return this.currentUser?.full_name || 'Admin';
  }

  get currentUser(): User | null {
    return this.authService.getCurrentUser();
  }

  get profileInitial(): string {
    return this.currentUserName.trim().charAt(0).toUpperCase() || 'A';
  }

  toggleProfileMenu(): void {
    this.isProfileMenuOpen = !this.isProfileMenuOpen;
  }

  closeProfileMenu(): void {
    this.isProfileMenuOpen = false;
  }

  async logout(): Promise<void> {
    this.authService.logout();
    this.closeProfileMenu();
    await this.router.navigate(['/login']);
  }

  ngOnDestroy(): void {
    if (this.clockTimer) {
      clearInterval(this.clockTimer);
    }
  }

  @HostListener('document:click')
  handleDocumentClick(): void {
    if (this.isProfileMenuOpen) {
      this.closeProfileMenu();
    }
  }
}
